import "flowbite";
import useAllFlashProducts from "hook/useAllFlashProducts";
import useFlashSaleData from "hook/useFlashSaleData";
import { useEffect, useRef, useState } from "react";
import "react-toastify/dist/ReactToastify.css";
import OrderNowModal from "models/orderNowModal";
import { useSettings } from "context/SettingsContext";
import { t } from "context/translations";
import CardDesign from "../components/cardDesign";
import ScrollToTopButton from "../components/ScrollToTopButton";
const HotOffer = () => {
  const { flashSaleData, loading } = useFlashSaleData();
  const [timeLeft, setTimeLeft] = useState(0);
  const { allProducts, loading1, error } = useAllFlashProducts();
  const [visibleCount, setVisibleCount] = useState(12);
  const loadMoreRef = useRef(null);
  const [isVisible, setIsVisible] = useState(true);
  const flashOfferProducts = allProducts.filter(
      (item) => item.flashOffer === 1,
  );
  const productsToShow = flashOfferProducts.slice(0, visibleCount);
  const hasMore = visibleCount < flashOfferProducts.length;
  const [orderModalOpen, setOrderModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const { language } = useSettings();

  useEffect(() => {
    if (!hasMore) return;

    const observer = new IntersectionObserver(
        (entries) => {
          if (entries[0].isIntersecting) {
            setVisibleCount((prev) =>
                Math.min(prev + 12, flashOfferProducts.length),
            );
          }
        },
        {
          rootMargin: "100px",
        },
    );

    const currentRef = loadMoreRef.current;
    if (currentRef) observer.observe(currentRef);

    return () => {
      if (currentRef) observer.unobserve(currentRef);
    };
  }, [hasMore, flashOfferProducts.length]);

  useEffect(() => {
    if (flashSaleData) {
      if (flashSaleData.available === false) {
        setIsVisible(false);
        return;
      }
      setIsVisible(true);
      setTimeLeft(Math.floor(flashSaleData.remaining_seconds));
    }
  }, [flashSaleData]);

  useEffect(() => {
    if (timeLeft <= 0) {
      setIsVisible(false);
      return;
    }

    const timer = setInterval(() => {
      setTimeLeft((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);

    return () => clearInterval(timer);
  }, [timeLeft]);

  const formatTime = (totalSeconds) => {
    totalSeconds = Math.max(0, Math.floor(totalSeconds));
    const days = Math.floor(totalSeconds / 86400);
    const hours = Math.floor((totalSeconds % 86400) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    return { days, hours, minutes, seconds };
  };

  const { days, hours, minutes, seconds } = formatTime(timeLeft || 0);
  if (loading1 || loading)
    return (
        <div className="flex justify-center items-center text-backgroundColor p-4">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-backgroundColor"></div>
        </div>
    );

  return (
      <div className=" flex flex-col min-h-[100dvh]">
        <div className="relative rounded-md mb-5 md:max-w-7xl mx-auto w-full">
          <div
              className="relative overflow-hidden bg-gradient-to-r from-red-600 via-orange-500 to-yellow-400 py-4 md:py-12 px-4 sm:px-6 md:px-10"
          >
            {/* Glow Effect */}
            <div className="absolute inset-0 bg-white/10 blur-2xl opacity-30"></div>

            {/* Content */}
            <div className="relative z-10 text-center">
              {/* Title */}
              <h1 className="text-white text-xl md:text-3xl lg:text-4xl font-bold tracking-tight">
                🔥 {t("shortTimeOffer", language)}
              </h1>

              <p className="text-white/90 text-sm md:text-base mt-1">
                {t("grabTheOffer", language)}
              </p>

              {/* Timer */}
              <div className="mt-3 grid grid-cols-4 gap-3 md:gap-6 max-w-3xl mx-auto">
                {[
                  { val: days,    key: "days" },
                  { val: hours,   key: "hours" },
                  { val: minutes, key: "minutes" },
                  { val: seconds, key: "seconds" },
                ].map(({ val, key }) => (
                    <div
                        key={key}
                        className="flex flex-col items-center justify-center rounded-xl bg-white/90 backdrop-blur-md  shadow-md py-3 md:py-5"
                    >
                  <span className="text-lg md:text-2xl lg:text-3xl font-bold text-[#FF4747]">
                    {val}
                  </span>
                      <span className="text-xs md:text-sm text-gray-600 mt-1">
                    {t(key, language)}
                  </span>
                    </div>
                ))}
              </div>
            </div>
          </div>
          <CardDesign likeData={productsToShow} />
        </div>
        <OrderNowModal
            isOpen={orderModalOpen}
            item={selectedItem}
            onClose={() => setOrderModalOpen(false)}
        />
        <ScrollToTopButton />
      </div>
  );
};

export default HotOffer;
